import React, { useState, useEffect } from 'react';
import { Input, Select, SelectOption } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';

import { MinimumValueRule } from '../../../../types/Rules';
import { Currencies } from '../Trips/Currencies';

import styles from './minimum-value.module.scss';

const MinimumValue = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const rule = rules.find(r => r.type === 'minimum_value') as MinimumValueRule | undefined;

  const ruleValue = rule?.value || { amount: 0, currency: 'EUR' };

  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: ruleValue.currency,
      minimumFractionDigits: 2,
    });
    setDisplayValue(formatter.format(ruleValue.amount));
  }, [ruleValue.amount, ruleValue.currency]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayValue(e.target.value);
  };

  const handleBlur = () => {
    const numericValue = parseFloat(displayValue.replace(/[^0-9.-]+/g, '')) || 0;
    handleRuleChange(
      {
        type: 'minimum_value',
        value: {
          ...ruleValue,
          amount: numericValue,
        },
      },
      numericValue === 0,
    );
  };

  return (
    <div className={styles.double}>
      <Select
        value={ruleValue.currency}
        extraClasses={styles.doubleInput}
        id='currency-input'
        label='Minimum value'
        onChange={e =>
          handleRuleChange({
            type: 'minimum_value',
            value: {
              ...ruleValue,
              currency: e.target.value,
            },
          })
        }
      >
        {Object.keys(Currencies).map(k => (
          <SelectOption key={k} value={k}>
            {Currencies[k]}
          </SelectOption>
        ))}
      </Select>
      <Input
        extraClasses={styles.doubleInput}
        name='voucher-min-value'
        id='voucher-min-value'
        label='&nbsp;'
        type='text'
        value={displayValue}
        onChange={handleChange}
        onBlur={handleBlur}
      />
    </div>
  );
};

export default MinimumValue;
